import { post } from "@insite/client-framework/Services/ApiService";

export interface DeliveryDateRequest {
    qty: number;
    zipCode: string;
    email: string;
    productNumber?: string;
    productTitle?: string;
    productUrl?: string;
}

export interface DeliveryDateResponse {
    message?: string;
}

const apiUrl = "/api/v2/getadeliverydateformylocation";

export function submitDeliveryDateForm(data: DeliveryDateRequest) {
    return post<any>(apiUrl, data) as Promise<DeliveryDateResponse>;
}
